import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { AuthenticationService } from '@core/authentication/services/authentication.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(private readonly _authenticationService: AuthenticationService) {}

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._checkAuthentication();
  }

  public canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._checkAuthentication();
  }

  /**
   * Vérifie l'authentification
   * Si environnement local, on autorise toujours
   * Sinon, on vérifie la validité du token
   * Si token invalide, on redirige vers la page d'erreur authentication-error, qui redirigera vers le login
   **/
  private _checkAuthentication() {
    return this._authenticationService.isAuthenticated();
  }
}
